import { getListTermApi } from '@/api/enter-score/term'
import { getListProfessorApi } from '@/api/enter-score/professor'
import { getListCourseApi } from '@/api/enter-score/course'
import { getListStudentApi } from '@/api/enter-score/student'
import { exportBarcodeApi, exportExcelApi, exportStatisticApi, exportExaStudentInvalid } from '@/api/enter-score/export'
import { storeScoreApi, uploadScoreApi } from '@/api/enter-score/score'
import { getSettingScoreApi, settingScoreApi } from '@/api/enter-score/setting'
import { getListImportEventApi, uploadBackupApi } from '@/api/enter-score/import'

const state = {
  terms: {
    pagination: {},
    list: []
  },
  professors: {
    pagination: {},
    list: []
  },
  courses: {
    pagination: {},
    list: []
  },
  students: {
    pagination: {},
    list: []
  },
  setting: {},
  importEvents: {
    pagination: {},
    list: []
  }
}

const getters = {
  getListTerm: (state) => {
    if (state.terms.list.length !== 0) {
      return state.terms.list
    }
    return []
  },
  getListProfessor: (state) => {
    if (state.professors.list.length !== 0) {
      return state.professors.list
    }
    return []
  },
  getListCourse: (state) => {
    if (state.courses.list.length !== 0) {
      return state.courses.list
    }
    return []
  },
  getListStudent: (state) => {
    if (state.students.list.length !== 0) {
      return state.students.list
    }
    return []
  },
  getSettingScore: (state) => {
    return state.setting
  },
  getListImportEvent: (state) => {
    if (state.importEvents.list.length !== 0) {
      return state.importEvents.list
    }
    return []
  },
  getPaginationImportEvent: (state) => {
    if (state.importEvents.pagination) {
      return state.importEvents.pagination
    }
    return {}
  }
}

const mutations = {
  SET_LIST_TERM: (state, listTerm) => {
    const {data, ...pagination} = listTerm
    state.terms = {pagination: pagination, list: data}
  },
  SET_LIST_PROFESSOR: (state, listProfessor) => {
    const {data, ...pagination} = listProfessor
    state.professors = {pagination: pagination, list: data}
  },
  SET_LIST_COURSE: (state, listCourse) => {
    const {data, ...pagination} = listCourse
    state.courses = {pagination: pagination, list: data}
  },
  SET_LIST_STUDENT: (state, listStudent) => {
    const {data, ...pagination} = listStudent
    state.students = {pagination: pagination, list: data}
  },
  SET_SETTING_SCORE: (state, setting) => {
    state.setting = setting
  },
  SET_LIST_IMPORT_EVENT: (state, listImportEvent) => {
    const {data, ...pagination} = listImportEvent
    state.importEvents = {pagination: pagination.meta, list: data}
  }
}

const actions = {
  async getListTermAction ({commit}, params) {
    try {
      const response = await getListTermApi(params)
      commit('SET_LIST_TERM', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async getListProfessorAction ({commit}, params) {
    try {
      const response = await getListProfessorApi(params)
      commit('SET_LIST_PROFESSOR', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async getListCourseAction ({commit}, params) {
    try {
      const response = await getListCourseApi(params)
      commit('SET_LIST_COURSE', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async getListStudentAction ({commit}, params) {
    try {
      const response = await getListStudentApi(params)
      commit('SET_LIST_STUDENT', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async exportBarcodeAction ({commit}, params) {
    try {
      const response = await exportBarcodeApi(params)
      return response
    } catch (e) {
      return e
    }
  },
  async exportExcelAction ({commit}, params) {
    try {
      const response = await exportExcelApi(params)
      return response
    } catch (e) {
      return e
    }
  },
  async exportStatisticAction ({commit}, params) {
    try {
      const response = await exportStatisticApi(params)
      return response
    } catch (e) {
      return e
    }
  },
  async exportExaStudentInvalidAction ({commit}, params) {
    try {
      const response = await exportExaStudentInvalid(params)
      return response
    } catch (e) {
      return e
    }
  },
  async storeScoreAction ({commit}, params) {
    try {
      const response = await storeScoreApi(params)
      return response
    } catch (e) {
      return e
    }
  },
  async uploadScoreAction ({commit}, params) {
    try {
      const response = await uploadScoreApi(params)
      return response
    } catch (e) {
      return e
    }
  },
  async getSettingScoreAction ({commit}, params) {
    try {
      const response = await getSettingScoreApi(params)
      commit('SET_SETTING_SCORE', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async settingScoreAction ({commit}, params) {
    try {
      const response = await settingScoreApi(params)
      return response
    } catch (e) {
      return e
    }
  },
  async getListImportEventAction ({commit}, params) {
    try {
      const response = await getListImportEventApi(params)
      commit('SET_LIST_IMPORT_EVENT', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async uploadBackupAction ({commit}, params) {
    try {
      const response = await uploadBackupApi(params)
      return response
    } catch (e) {
      return e
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/enter-score.js